import { CommonModule, isPlatformServer } from '@angular/common';
import { Component, ElementRef, Inject, Input, OnChanges, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { sleep } from 'src/app/lib/sleep';
import { StoryblokCdnPipe } from '../../pipes/storyblok-cdn.pipe';
import { StoryblokImage } from '../../storyblok-types';
import { BlockStyle, BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';

@Component({
  selector: 'app-video',
  standalone: true,
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
  imports: [CommonModule, BlockWrapperComponent, StoryblokCdnPipe],
})
export class VideoComponent implements OnInit, OnChanges {
  @ViewChild('videoEl') videoEl: ElementRef<HTMLVideoElement>;
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;
  @Input() style: BlockStyle[];

  @Input() video: StoryblokImage;
  @Input() poster: StoryblokImage;

  dimensions: {
    width: number;
    height: number;
  };

  constructor(@Inject(PLATFORM_ID) private platformId: string) {}

  async ngOnInit() {
    if (isPlatformServer(this.platformId)) return;
    await sleep(0);
    if (this.videoEl) {
      this.videoEl.nativeElement.muted = true;
      this.videoEl.nativeElement.autoplay = true;
    }
  }

  ngOnChanges() {
    const url = this.poster?.filename;
    if (!url) return;
    this.dimensions = {
      width: parseInt(url.split('/')[5].split('x')[0]),
      height: parseInt(url.split('/')[5].split('x')[1]),
    };
  }
}
